import { Modal, type StackProps } from '@chakra-ui/react';

export type UiModalProps = StackProps;

export const UiModal = Modal;
